//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './SharedPortfoliosClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SharedPortfoliosGetListSharedPortfoliosQueryParameters = {
  skipCount?: number | undefined ;
  maxResultCount?: number | undefined ;
}

export type SharedPortfoliosGetSharedPortfolioSharedPortfoliosQueryParameters = {
  id: string ;
}

export type SharedPortfoliosCreateOrUpdateSharedPortfolioSharedPortfoliosQueryParameters = {
  id: string ;
}

export type SharedPortfoliosDeleteSharedPortfolioUserSharedPortfoliosQueryParameters = {
  id: string ;
}

export type SharedPortfoliosGetSharedPortfolioSettingsSharedPortfoliosQueryParameters = {
  id: string ;
}

export type SharedPortfoliosGetTimeSeriesSharedPortfoliosQueryParameters = {
  id: string ;
  start?: string | undefined ;
  end?: string | undefined ;
  includeTransactions?: boolean | undefined ;
}

export type SharedPortfoliosAcceptSharedPortfolioSharedPortfoliosQueryParameters = {
  id: string ;
}

export type SharedPortfoliosRevokeShareAccessSharedPortfoliosQueryParameters = {
  id: string ;
}

export function sharedPortfoliosGetListUrl(skipCount?: number | undefined, maxResultCount?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/portfolios/shared?";
if (skipCount === null)
    throw new Error("The parameter 'skipCount' cannot be null.");
else if (skipCount !== undefined)
    url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
if (maxResultCount === null)
    throw new Error("The parameter 'maxResultCount' cannot be null.");
else if (maxResultCount !== undefined)
    url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let sharedPortfoliosGetListDefaultOptions: Omit<UseQueryOptions<Types.PagedResultDtoOfSharedPortfolioDto, unknown, Types.PagedResultDtoOfSharedPortfolioDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultDtoOfSharedPortfolioDto, unknown, Types.PagedResultDtoOfSharedPortfolioDto>, 'queryFn'>> = {
};
export function getSharedPortfoliosGetListDefaultOptions() {
  return sharedPortfoliosGetListDefaultOptions;
};
export function setSharedPortfoliosGetListDefaultOptions(options: typeof sharedPortfoliosGetListDefaultOptions) {
  sharedPortfoliosGetListDefaultOptions = options;
}

export function sharedPortfoliosGetListQueryKey(dto: SharedPortfoliosGetListSharedPortfoliosQueryParameters): QueryKey;
export function sharedPortfoliosGetListQueryKey(skipCount?: number | undefined, maxResultCount?: number | undefined): QueryKey;
export function sharedPortfoliosGetListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { skipCount, maxResultCount,  } = params[0] as SharedPortfoliosGetListSharedPortfoliosQueryParameters;

    return trimArrayEnd([
        'SharedPortfoliosClient',
        'sharedPortfoliosGetList',
        skipCount as any,
        maxResultCount as any,
      ]);
  } else {
    return trimArrayEnd([
        'SharedPortfoliosClient',
        'sharedPortfoliosGetList',
        ...params
      ]);
  }
}
export function __sharedPortfoliosGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.sharedPortfoliosGetList(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as number | undefined,axiosConfig    );
}

export function useSharedPortfoliosGetListQuery<TSelectData = Types.PagedResultDtoOfSharedPortfolioDto, TError = unknown>(dto: SharedPortfoliosGetListSharedPortfoliosQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfSharedPortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function useSharedPortfoliosGetListQuery<TSelectData = Types.PagedResultDtoOfSharedPortfolioDto, TError = unknown>(skipCount?: number | undefined, maxResultCount?: number | undefined, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfSharedPortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSharedPortfoliosGetListQuery<TSelectData = Types.PagedResultDtoOfSharedPortfolioDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultDtoOfSharedPortfolioDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let skipCount: any = undefined;
  let maxResultCount: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ skipCount, maxResultCount,  } = params[0] as SharedPortfoliosGetListSharedPortfoliosQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [skipCount, maxResultCount, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultDtoOfSharedPortfolioDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __sharedPortfoliosGetList(context, axiosConfig) : __sharedPortfoliosGetList,
    queryKey: sharedPortfoliosGetListQueryKey(skipCount, maxResultCount),
    ...sharedPortfoliosGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultDtoOfSharedPortfolioDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setSharedPortfoliosGetListData(queryClient: QueryClient, updater: (data: Types.PagedResultDtoOfSharedPortfolioDto | undefined) => Types.PagedResultDtoOfSharedPortfolioDto, skipCount?: number | undefined, maxResultCount?: number | undefined) {
  queryClient.setQueryData(sharedPortfoliosGetListQueryKey(skipCount, maxResultCount),
    updater
  );
}

/**
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setSharedPortfoliosGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultDtoOfSharedPortfolioDto | undefined) => Types.PagedResultDtoOfSharedPortfolioDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function sharedPortfoliosGetSharedPortfolioUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/shared/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let sharedPortfoliosGetSharedPortfolioDefaultOptions: Omit<UseQueryOptions<Types.PortfolioDto, unknown, Types.PortfolioDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PortfolioDto, unknown, Types.PortfolioDto>, 'queryFn'>> = {
};
export function getSharedPortfoliosGetSharedPortfolioDefaultOptions() {
  return sharedPortfoliosGetSharedPortfolioDefaultOptions;
};
export function setSharedPortfoliosGetSharedPortfolioDefaultOptions(options: typeof sharedPortfoliosGetSharedPortfolioDefaultOptions) {
  sharedPortfoliosGetSharedPortfolioDefaultOptions = options;
}

export function sharedPortfoliosGetSharedPortfolioQueryKey(id: string): QueryKey;
export function sharedPortfoliosGetSharedPortfolioQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as SharedPortfoliosGetSharedPortfolioSharedPortfoliosQueryParameters;

    return trimArrayEnd([
        'SharedPortfoliosClient',
        'sharedPortfoliosGetSharedPortfolio',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'SharedPortfoliosClient',
        'sharedPortfoliosGetSharedPortfolio',
        ...params
      ]);
  }
}
export function __sharedPortfoliosGetSharedPortfolio(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.sharedPortfoliosGetSharedPortfolio(
      context.queryKey[2] as string,axiosConfig    );
}

export function useSharedPortfoliosGetSharedPortfolioQuery<TSelectData = Types.PortfolioDto, TError = unknown>(dto: SharedPortfoliosGetSharedPortfolioSharedPortfoliosQueryParameters, options?: Omit<UseQueryOptions<Types.PortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useSharedPortfoliosGetSharedPortfolioQuery<TSelectData = Types.PortfolioDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.PortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSharedPortfoliosGetSharedPortfolioQuery<TSelectData = Types.PortfolioDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PortfolioDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as SharedPortfoliosGetSharedPortfolioSharedPortfoliosQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PortfolioDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __sharedPortfoliosGetSharedPortfolio(context, axiosConfig) : __sharedPortfoliosGetSharedPortfolio,
    queryKey: sharedPortfoliosGetSharedPortfolioQueryKey(id),
    ...sharedPortfoliosGetSharedPortfolioDefaultOptions as unknown as Omit<UseQueryOptions<Types.PortfolioDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setSharedPortfoliosGetSharedPortfolioData(queryClient: QueryClient, updater: (data: Types.PortfolioDto | undefined) => Types.PortfolioDto, id: string) {
  queryClient.setQueryData(sharedPortfoliosGetSharedPortfolioQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setSharedPortfoliosGetSharedPortfolioDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PortfolioDto | undefined) => Types.PortfolioDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function sharedPortfoliosCreateOrUpdateSharedPortfolioUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/shared/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sharedPortfoliosCreateOrUpdateSharedPortfolioMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'SharedPortfoliosClient',
      'sharedPortfoliosCreateOrUpdateSharedPortfolio',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useSharedPortfoliosCreateOrUpdateSharedPortfolioMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.SharedPortfolioDto, unknown, Types.SharedPortfolioSettings, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SharedPortfolioDto, unknown, Types.SharedPortfolioSettings, TContext> {
  const key = sharedPortfoliosCreateOrUpdateSharedPortfolioMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SharedPortfolioSettings) => Client.sharedPortfoliosCreateOrUpdateSharedPortfolio(id, body),
    mutationKey: key,
  });
}
  
type SharedPortfoliosCreateOrUpdateSharedPortfolio__MutationParameters = SharedPortfoliosCreateOrUpdateSharedPortfolioSharedPortfoliosQueryParameters & {
  body: Types.SharedPortfolioSettings;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useSharedPortfoliosCreateOrUpdateSharedPortfolioMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.SharedPortfolioDto, unknown, SharedPortfoliosCreateOrUpdateSharedPortfolio__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SharedPortfoliosCreateOrUpdateSharedPortfolioSharedPortfoliosQueryParameters}): UseMutationResult<Types.SharedPortfolioDto, unknown, SharedPortfoliosCreateOrUpdateSharedPortfolio__MutationParameters, TContext> {
  const key = sharedPortfoliosCreateOrUpdateSharedPortfolioMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SharedPortfoliosCreateOrUpdateSharedPortfolio__MutationParameters) => Client.sharedPortfoliosCreateOrUpdateSharedPortfolio(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function sharedPortfoliosDeleteSharedPortfolioUserUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/shared/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sharedPortfoliosDeleteSharedPortfolioUserMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'SharedPortfoliosClient',
      'sharedPortfoliosDeleteSharedPortfolioUser',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useSharedPortfoliosDeleteSharedPortfolioUserMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = sharedPortfoliosDeleteSharedPortfolioUserMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sharedPortfoliosDeleteSharedPortfolioUser(id),
    mutationKey: key,
  });
}
  
type SharedPortfoliosDeleteSharedPortfolioUser__MutationParameters = SharedPortfoliosDeleteSharedPortfolioUserSharedPortfoliosQueryParameters

/**
 * @return OK
 */
export function useSharedPortfoliosDeleteSharedPortfolioUserMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SharedPortfoliosDeleteSharedPortfolioUser__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SharedPortfoliosDeleteSharedPortfolioUserSharedPortfoliosQueryParameters}): UseMutationResult<void, unknown, SharedPortfoliosDeleteSharedPortfolioUser__MutationParameters, TContext> {
  const key = sharedPortfoliosDeleteSharedPortfolioUserMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SharedPortfoliosDeleteSharedPortfolioUser__MutationParameters) => Client.sharedPortfoliosDeleteSharedPortfolioUser(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function sharedPortfoliosGetSharedPortfolioSettingsUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/shared/{id}/settings";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let sharedPortfoliosGetSharedPortfolioSettingsDefaultOptions: Omit<UseQueryOptions<Types.SharedPortfolioDto, unknown, Types.SharedPortfolioDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SharedPortfolioDto, unknown, Types.SharedPortfolioDto>, 'queryFn'>> = {
};
export function getSharedPortfoliosGetSharedPortfolioSettingsDefaultOptions() {
  return sharedPortfoliosGetSharedPortfolioSettingsDefaultOptions;
};
export function setSharedPortfoliosGetSharedPortfolioSettingsDefaultOptions(options: typeof sharedPortfoliosGetSharedPortfolioSettingsDefaultOptions) {
  sharedPortfoliosGetSharedPortfolioSettingsDefaultOptions = options;
}

export function sharedPortfoliosGetSharedPortfolioSettingsQueryKey(id: string): QueryKey;
export function sharedPortfoliosGetSharedPortfolioSettingsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as SharedPortfoliosGetSharedPortfolioSettingsSharedPortfoliosQueryParameters;

    return trimArrayEnd([
        'SharedPortfoliosClient',
        'sharedPortfoliosGetSharedPortfolioSettings',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'SharedPortfoliosClient',
        'sharedPortfoliosGetSharedPortfolioSettings',
        ...params
      ]);
  }
}
export function __sharedPortfoliosGetSharedPortfolioSettings(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.sharedPortfoliosGetSharedPortfolioSettings(
      context.queryKey[2] as string,axiosConfig    );
}

export function useSharedPortfoliosGetSharedPortfolioSettingsQuery<TSelectData = Types.SharedPortfolioDto, TError = unknown>(dto: SharedPortfoliosGetSharedPortfolioSettingsSharedPortfoliosQueryParameters, options?: Omit<UseQueryOptions<Types.SharedPortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useSharedPortfoliosGetSharedPortfolioSettingsQuery<TSelectData = Types.SharedPortfolioDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.SharedPortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSharedPortfoliosGetSharedPortfolioSettingsQuery<TSelectData = Types.SharedPortfolioDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SharedPortfolioDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as SharedPortfoliosGetSharedPortfolioSettingsSharedPortfoliosQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SharedPortfolioDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __sharedPortfoliosGetSharedPortfolioSettings(context, axiosConfig) : __sharedPortfoliosGetSharedPortfolioSettings,
    queryKey: sharedPortfoliosGetSharedPortfolioSettingsQueryKey(id),
    ...sharedPortfoliosGetSharedPortfolioSettingsDefaultOptions as unknown as Omit<UseQueryOptions<Types.SharedPortfolioDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setSharedPortfoliosGetSharedPortfolioSettingsData(queryClient: QueryClient, updater: (data: Types.SharedPortfolioDto | undefined) => Types.SharedPortfolioDto, id: string) {
  queryClient.setQueryData(sharedPortfoliosGetSharedPortfolioSettingsQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setSharedPortfoliosGetSharedPortfolioSettingsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SharedPortfolioDto | undefined) => Types.SharedPortfolioDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function sharedPortfoliosGetTimeSeriesUrl(id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/portfolios/shared/{id}/timeseries?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (start === null)
    throw new Error("The parameter 'start' cannot be null.");
else if (start !== undefined)
    url_ += "Start=" + encodeURIComponent("" + start) + "&";
if (end === null)
    throw new Error("The parameter 'end' cannot be null.");
else if (end !== undefined)
    url_ += "End=" + encodeURIComponent("" + end) + "&";
if (includeTransactions === null)
    throw new Error("The parameter 'includeTransactions' cannot be null.");
else if (includeTransactions !== undefined)
    url_ += "IncludeTransactions=" + encodeURIComponent("" + includeTransactions) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let sharedPortfoliosGetTimeSeriesDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfBucketDto, unknown, Types.ListResultDtoOfBucketDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfBucketDto, unknown, Types.ListResultDtoOfBucketDto>, 'queryFn'>> = {
};
export function getSharedPortfoliosGetTimeSeriesDefaultOptions() {
  return sharedPortfoliosGetTimeSeriesDefaultOptions;
};
export function setSharedPortfoliosGetTimeSeriesDefaultOptions(options: typeof sharedPortfoliosGetTimeSeriesDefaultOptions) {
  sharedPortfoliosGetTimeSeriesDefaultOptions = options;
}

export function sharedPortfoliosGetTimeSeriesQueryKey(dto: SharedPortfoliosGetTimeSeriesSharedPortfoliosQueryParameters): QueryKey;
export function sharedPortfoliosGetTimeSeriesQueryKey(id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined): QueryKey;
export function sharedPortfoliosGetTimeSeriesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, start, end, includeTransactions,  } = params[0] as SharedPortfoliosGetTimeSeriesSharedPortfoliosQueryParameters;

    return trimArrayEnd([
        'SharedPortfoliosClient',
        'sharedPortfoliosGetTimeSeries',
        id as any,
        start as any,
        end as any,
        includeTransactions as any,
      ]);
  } else {
    return trimArrayEnd([
        'SharedPortfoliosClient',
        'sharedPortfoliosGetTimeSeries',
        ...params
      ]);
  }
}
export function __sharedPortfoliosGetTimeSeries(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.sharedPortfoliosGetTimeSeries(
      context.queryKey[2] as string,       context.queryKey[3] as string | undefined,       context.queryKey[4] as string | undefined,       context.queryKey[5] as boolean | undefined,axiosConfig    );
}

export function useSharedPortfoliosGetTimeSeriesQuery<TSelectData = Types.ListResultDtoOfBucketDto, TError = unknown>(dto: SharedPortfoliosGetTimeSeriesSharedPortfoliosQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfBucketDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param start (optional) 
 * @param end (optional) 
 * @param includeTransactions (optional) 
 * @return OK
 */
export function useSharedPortfoliosGetTimeSeriesQuery<TSelectData = Types.ListResultDtoOfBucketDto, TError = unknown>(id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined, options?: Omit<UseQueryOptions<Types.ListResultDtoOfBucketDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSharedPortfoliosGetTimeSeriesQuery<TSelectData = Types.ListResultDtoOfBucketDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfBucketDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let start: any = undefined;
  let end: any = undefined;
  let includeTransactions: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, start, end, includeTransactions,  } = params[0] as SharedPortfoliosGetTimeSeriesSharedPortfoliosQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, start, end, includeTransactions, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfBucketDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __sharedPortfoliosGetTimeSeries(context, axiosConfig) : __sharedPortfoliosGetTimeSeries,
    queryKey: sharedPortfoliosGetTimeSeriesQueryKey(id, start, end, includeTransactions),
    ...sharedPortfoliosGetTimeSeriesDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfBucketDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param start (optional) 
 * @param end (optional) 
 * @param includeTransactions (optional) 
 * @return OK
 */
export function setSharedPortfoliosGetTimeSeriesData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfBucketDto | undefined) => Types.ListResultDtoOfBucketDto, id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined) {
  queryClient.setQueryData(sharedPortfoliosGetTimeSeriesQueryKey(id, start, end, includeTransactions),
    updater
  );
}

/**
 * @param start (optional) 
 * @param end (optional) 
 * @param includeTransactions (optional) 
 * @return OK
 */
export function setSharedPortfoliosGetTimeSeriesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfBucketDto | undefined) => Types.ListResultDtoOfBucketDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function sharedPortfoliosAcceptSharedPortfolioUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/shared/{id}/accept";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sharedPortfoliosAcceptSharedPortfolioMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'SharedPortfoliosClient',
      'sharedPortfoliosAcceptSharedPortfolio',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useSharedPortfoliosAcceptSharedPortfolioMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.SharedPortfolioDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SharedPortfolioDto, unknown, void, TContext> {
  const key = sharedPortfoliosAcceptSharedPortfolioMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sharedPortfoliosAcceptSharedPortfolio(id),
    mutationKey: key,
  });
}
  
type SharedPortfoliosAcceptSharedPortfolio__MutationParameters = SharedPortfoliosAcceptSharedPortfolioSharedPortfoliosQueryParameters

/**
 * @return OK
 */
export function useSharedPortfoliosAcceptSharedPortfolioMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.SharedPortfolioDto, unknown, SharedPortfoliosAcceptSharedPortfolio__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SharedPortfoliosAcceptSharedPortfolioSharedPortfoliosQueryParameters}): UseMutationResult<Types.SharedPortfolioDto, unknown, SharedPortfoliosAcceptSharedPortfolio__MutationParameters, TContext> {
  const key = sharedPortfoliosAcceptSharedPortfolioMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SharedPortfoliosAcceptSharedPortfolio__MutationParameters) => Client.sharedPortfoliosAcceptSharedPortfolio(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function sharedPortfoliosRevokeShareAccessUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/shared/{id}/revoke";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sharedPortfoliosRevokeShareAccessMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'SharedPortfoliosClient',
      'sharedPortfoliosRevokeShareAccess',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useSharedPortfoliosRevokeShareAccessMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = sharedPortfoliosRevokeShareAccessMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sharedPortfoliosRevokeShareAccess(id),
    mutationKey: key,
  });
}
  
type SharedPortfoliosRevokeShareAccess__MutationParameters = SharedPortfoliosRevokeShareAccessSharedPortfoliosQueryParameters

/**
 * @return OK
 */
export function useSharedPortfoliosRevokeShareAccessMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SharedPortfoliosRevokeShareAccess__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SharedPortfoliosRevokeShareAccessSharedPortfoliosQueryParameters}): UseMutationResult<void, unknown, SharedPortfoliosRevokeShareAccess__MutationParameters, TContext> {
  const key = sharedPortfoliosRevokeShareAccessMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SharedPortfoliosRevokeShareAccess__MutationParameters) => Client.sharedPortfoliosRevokeShareAccess(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}